import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { $api } from '../../api/queryClient'
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card'

/**
 * The plans that draw a network asset (spec 2026-10-20-33). A network filed
 * at the building or the site is drawn on several floors: each row opens that
 * floor's plan editor.
 */
export function NetworkPlansCard({ org, assetUid }: { org: string; assetUid: string }) {
    const { t } = useTranslation('assets')
    const { data } = $api.useQuery('get', '/api/v1/organizations/{orgCode}/assets/{assetUid}/network-plans', {
        params: { path: { orgCode: org, assetUid } },
    })
    if (!data) return null
    const plans = data.data ?? []

    return (
        <Card data-testid="network-plans">
            <CardHeader className="pb-2">
                <CardTitle className="text-base">{t('network_plans.title')}</CardTitle>
            </CardHeader>
            <CardContent>
                {plans.length === 0 ? (
                    <p className="text-sm text-muted-foreground" data-testid="network-plans-empty">{t('network_plans.empty')}</p>
                ) : (
                    <ul className="divide-y divide-border">
                        {plans.map((plan) => (
                            <li key={plan.uid} className="py-2" data-testid={`network-plan-${plan.uid}`}>
                                <Link
                                    to="/$org/assets/$assetUid/plan-editor"
                                    params={{ org, assetUid: plan.uid }}
                                    title={t('network_plans.open_plan')}
                                    className="text-sm font-medium text-foreground hover:text-primary hover:underline"
                                    data-testid={`network-plan-link-${plan.uid}`}
                                >
                                    {plan.name || plan.uid}
                                </Link>
                            </li>
                        ))}
                    </ul>
                )}
            </CardContent>
        </Card>
    )
}
